import React from 'react';
import { Button } from '@THC/components/Button';
import Link from 'next/link';

import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { motorwayPayModulrEvents } from 'Services/analytics/events/paymentEvents/motorwayPayModulrEvents';
import ROUTES from 'Utilities/routes';

import styles from './SignUpToMotorwayPayBox.module.scss';

export const SignUpToMotorwayPayBox: React.FC = () => (
	<div className={styles.wrapper}>
		<h3>Sign up to Motorway&nbsp;Pay</h3>
		<p>The fast, transparent and secure way to make payments for vehicles</p>
		<Link legacyBehavior passHref href={ROUTES.MOTORWAY_PAY.href}>
			<Button
				fullWidth
				as="a"
				label={<>More about Motorway&nbsp;Pay</>}
				onClick={() => {
					motorwayPayModulrEvents<{
						label: string | null;
					}>({
						customData: {
							label: 'More about Motorway Pay',
						},
						name: 'Button clicked',
						schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
						version: SNOWPLOW_EVENTS.CLICK.VERSION,
					});
				}}
				target="_blank"
			/>
		</Link>
	</div>
);
